import { render, staticRenderFns } from "./CustomBooleanCellRenderer.vue?vue&type=template&id=4432e510&scoped=true&"
import script from "./CustomBooleanCellRenderer.vue?vue&type=script&lang=js&"
export * from "./CustomBooleanCellRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4432e510",
  null
  
)

export default component.exports